export default __webpack_public_path__ + "static/logo-goplana-osiedle-color-ccdf054de057ae5367c8ee1e96d351dd.jpg";